export enum Roles {
    'Admin',
    'Franchise',
    'WareHouse'
}

export enum PackageListingSearchEnum {
    ArrivedAtLocalWareHouse = 17,
    Archived = 14,
    Attached = 1,
    AvailableToShip = 3,
    Delivered = 18,
    Discarded = 11,
    DiscardRequestPending = 10,
    OnHold = 15,
    Overpacked = 4,
    PendingReturnPayment = 8,
    PendingReturnShipment = 12,
    PendingShipment = 13,
    Restricted = 5,
    ReturnRequestPending = 7,
    Shipped = 6,
    ShipmentReturned = 9,
    ShipmentFulfilled = 16,
    Unknown = 2,
    CancelledShipment = 19,
    HoldToShip = 20,
    AutoDiscarded = 21
}

export enum PackageListingSearchEnum1 {
    "Arrived At Local WareHouse" = 17,
    "Archived" = 14,
    "Attached" = 1,
    "Available To Ship" = 3,
    "Delivered" = 18,
    "Discarded" = 11,
    "Discard Request Pending" = 10,
    "On Hold" = 15,
    "Overpacked" = 4,
    "Pending Return/Forward Payment" = 8,
    "Paid Return/Forward Shipment" = 12,
    "Pending Shipment" = 13,
    "Restricted" = 5,
    "Return/Forward Request Pending" = 7,
    "Shipped" = 6,
    "Return/Forward Shipped" = 9,
    "Shipment Fulfilled" = 16,
    "Unknown" = 2,
    "Cancelled Shipment" = 19,
    "Hold To Ship" = 20,
    "Auto Discarded" = 21
}


export enum PackageListingSearchForBinLocation {
    "Arrived At Local WareHouse" = 17,
    "Archived" = 14,
    "Attached" = 1,
    "Available To Ship" = 3,
    "Discard Request Pending" = 10,
    "On Hold" = 15,
    "Pending Return/Forward Payment" = 8,
    "Paid Return/Forward Shipment" = 12,
    "Pending Shipment" = 13,
    "Return/Forward Request Pending" = 7,
    "Unknown" = 2,
    "Cancelled Shipment" = 19
}


export enum DirectShipmentSearchEnum {
    PendingShipment = 13,
    ReadyToShip = 12,
    Shipped = 6,
    ShipmentFulfilled = 16,
    Delivered = 18,
    "Cancelled Shipment" = 19


}

export enum DirectShipmentSearchEnum1 {
    "Pending Shipment" = 13,
    "Ready To Ship" = 12,
    "Shipped" = 6,
    "Shipment Fulfilled" = 16,
    "Delivered" = 18,
    "Cancelled Shipment" = 19
}

export enum ItemStatusEnum {
    OkayToShip = 1,
    OnHold = 3,
    Restricted = 2
}
export enum OverpackListingSearchEnum {
    InProcess = 1,
    Ready = 2,
    Shipped = 3,
    Delivered = 4
}

export enum PostTypeCategoryEnum {
    RestrictedKeywords = 1,
    HarmonizedCodes = 2,
    SpecialLabels = 3,
    HoldReasons = 4,
    RestrictedItems = 5
}

export enum ShipmentListingSearchEnum {
    ArrivedAtLocalWareHouse = 1,
    Delivered = 2,
    InTransit = 5,
    Shipped = 3,
    Unshipped = 4,
}

export enum ShipmentListingSearchEnum1 {
    "Arrived At Local WareHouse" = 1,
    "Delivered" = 2,
    "In Transit" = 5,
    "Shipped" = 3,
    "Unshipped" = 4,
}


export enum ChargesTypeEnum {
    Code = 1,
    IssueCredit = 2,
    EditCharges = 3,
    ProcessReturn = 4
}

export enum WeekDaysEnum {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
    Sunday = 0
}

export enum WeekDayEnum {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3
}

export enum ShipmentStatusEnum {
    ArrivedAtLocalWareHouse = 1,
    Delivered = 2,
    Shipped = 3,
    Unshipped = 4,
    InTransit = 5
}


export enum WightMessure {
    KG,
    LBS
}

export enum ShippingMethodEnum {
    Consolidation,
    Direct
}
/*
export enum InvoiceType {
    BoxReturn = 1,
    Credit = 2,
    Paid = 3,
    UnPaid = 4,
    Commercial = 5,
    Invoice = 6
}
*/
export enum InvoiceType {
    BoxReturn = 1,
    Credit = 2,
    VoidCreditCardVerfication = 3,
    AccountSetUp = 4,
    RefundCreditCardVerification = 5,
    Invoice = 6,
    Custom = 7,
    CreditCardVerification = 8
}

export enum InvoiceTypeStr {
    "Box Return" = 1,
    "Credit" = 2,
    "Void CreditCard Verfication" = 3,
    "Account SetUp" = 4,
    "Refund Credit Card Verification" = 5,
    "Invoice" = 6,
    "Custom" = 7,
    "Credit Card Verification" = 8
}



export enum ShipmentType {
    Consolidation = 1,
    Direct = 2,
}

export enum InvoiceStatus {
    Consolidated = 5,
    Paid = 2,
    Pending = 1
}

export enum InvoiceProcessStatus {
    NotStarted = 1,
    InProcess = 2,
    Completed = 3,
    Error = 4
}

export enum PaymentMethod {
    Account = 3,
    Cash = 2,
    PayPalOrCreditCard = 1
}
export enum PackageStatusEnum {
    Attached = 1,
    Unknown = 2,
    AvailableToShip = 3,
    Overpacked = 4,
    Restricted = 5,
    Shipped = 6,
    ReturnRequestPending = 7,
    PendingReturnPayment = 8,
    ShippedReturn = 9,
    DiscardRequestPending = 10,
    Discarded = 11,
    ReadyToShip = 12,
    PendingShipment = 13,
    Archived = 14,
    OnHold = 15,
    ArrivedAtLocalWareHouse = 17,
    HoldToShip = 20,
    AutoDiscarded = 21
}
export enum PickTicketStatus {
    Open = 1,
    //Close = 2,
    Closed = 3,
    Cancel = 4
}

export enum ReturnReason {
    MerchantSentWrongItem = 1,
    ProhibitedforTransport = 2,
    DontWantItemAnymore = 3,
    ShippingCosttooHigh = 4,
    Other = 5
}

export enum ReturnTypeEnum {
    Return = 1,
    Discard = 2,
    PartialReturn = 3,
    PartialDiscard = 4
}

export enum RequestTypeEnum {
    ReturnForward = 1,
    Discard = 2
}

export enum CreditRefundType {
    Invoice = 1,
    Customer = 2,
    General = 3
}

export enum InvoiceChargesType {
    Code = 1,
    EditCharges = 3,
    IssueCredit = 2,
    ProcessReturn = 4
}

export enum CustomerSupportRequestStatus {
    "AwaitingCustomerResponse" = 5,
    "Closed" = 2,
    "CustomerResponded" = 4,
    "Open" = 1,
    "Pending" = 3,
    "Reopen" = 6,
}


export enum CustomerSupportRequestStatus1 {
    "Awaiting Customer Response" = 5,
    "Closed" = 2,
    "Customer Responded" = 4,
    "Open" = 1,
    "Pending" = 3,
    "Reopen" = 6,
}

export enum CategoryType {
    CannedResponse = 2,
    FAQs = 1,
    RestrictedItems = 3
}

export enum FaqFor {
    'Franchisee Portal' = 1,
    'Warehouse Portal' = 2,
    'Website' = 3
}

export enum TutorialFor {
    'Franchisee Portal' = 1,
    'Warehouse Portal' = 2,
    'Website' = 3
}

export enum PortalType {
    WareHouse = 3,
    Franchise = 1
}

export enum SiteSettingsCategory {
    ChargeSettings = 1,
    ProcessingSettings = 2,
    EmailSettings = 3,
    TotalSettings = 4,
    ContactInformation = 5,
    MiscellaneousInformation = 6,
    TransportationweightandRates = 7,
    MembershipSettings = 8,
    BuyingServiceFeeSettings = 9,
    NewsletterFooter = 10
}

export enum CustomerStatus {
    Active = 0,
    Close = 2,
    Delete = 3,
    Incomplete = 4,
    Suspend = 1,
    Unverify = 5,
}
export enum Panel {
    Franchise = 1,
    Admin = 2,
    WareHouse = 3
}
export enum DiscountStatus {
    Active = 1,
    Expired = 3,
    Pending = 2
}

export enum Factor {
    Amount = 1,
    Percentage = 2
}

export enum PromotionalFor {
    Invoice = 2,
    Registration = 1
}

export enum PaymentGateway {
    Paypal = 1,
    Authorize = 2
}

export enum DeliveryType {
    Home = 0,
    Pickup = 1
}

export enum ShipmentStatusForFr {
    ArrivedAtLocalWareHouse = 1,
    Delivered = 2,
}

export enum PackageStatus {
    ArrivedAtLocalWareHouse = 17,
    Delivered = 18,
}

export enum SearchOptions {
    Package = 1,
    Invoice = 2,
    Customer = 3,
    Shipment = 4,
    Overpack = 5,
    'Tracking No.' = 6,
    BOL = 7,
}
export enum TemplateType {
    WebsiteRegistration = 1,
    Registration = 2,
    PersonalShopper = 3,
    SupportTicket = 4,
    InternalSupportRequest = 5,
    PackageNotification = 6,
    CustomInvoice = 7,
    ChangePassword = 8,
    InvoicePaymentNotification = 9,
    IssueCreditNotification = 10,
    DirectServiceNotification = 11,
    ClaimNotification = 12
}

export enum ShippingDocumentType {
    "Individual Commercial Invoice" = 1,
    "Consolidation Commercial Invoice" = 2,
    "Shipment Manifest" = 3,
    "Consolidation Package List" = 4,
    "Shipment Pull Ticket Manifest" = 5,
    "Shipping Label Batch Print" = 6,
    "Delivery Receipts" = 7,
    "AZE Package Commercial Invoice" = 8,
    "Overpack Label Batch Print" = 9,
    "Package Commercial Invoice" = 10,
    "AZE package Commercial Labels" = 11
}

export enum NewsletterStatus {
    Draft = 2,
    Sent = 1
}

export enum InvoiceReportStatus {
    AccountCredit = 4,
    Consolidated = 5,
    Paid = 1,
    Pending = 2,
    Refunded = 3,

}

export enum DeliveredInvoice {
    No = 2,
    Yes = 1
}

export enum ImageType {
    ItemImage = 1,
    Label = 2,
    MergeImage = 3,
    Merge_Item = 4
}
export enum ClaimType {
    Damaged = 2,
    Lost = 1
}

export enum TutorialMediaType {
    Pdf = 1,
    Image = 2,
    Other = 3,
    Video = 4
}

export enum CuorierTypes{
    DHL=1,
    FedEx=3
}
